import { Controller } from "@hotwired/stimulus"

export default class CoreuiCarouselControlController extends Controller {
  static outlets = ["coreui-carousel"]

  next() {
    this.coreuiCarouselOutlets.forEach((owner) => owner.next())
  }

  prev() {
    this.coreuiCarouselOutlets.forEach((owner) => owner.prev())
  }

  to(event) {
    this.coreuiCarouselOutlets.forEach((owner) => owner.to(event))
  }
}
